import { defineMessages } from 'react-intl';

export const hireLandingPageMessages = defineMessages({
  heroTitle: {
    id: 'text-landing-page-hero',
    defaultMessage: 'Hire in Days, Not Weeks. Start for Free Today!',
  },
  heroSubtitle: {
    id: 'modules.Landing.newLanding.heroSubtitle',
    defaultMessage: 'Free Today!',
  },
  whatsAppPlaceholder: {
    id: 'text-placeholder-enter-wa',
    defaultMessage: 'Enter your WhatsApp Number',
  },
  invalidPhoneNumber: {
    id: 'text-error-invalid-phone-number',
    defaultMessage:
      'Use a valid format which does not start with 0. Example: 81234567.',
  },
  requiredPhoneNumber: {
    id: 'text-this-field-is-required',
    defaultMessage: 'This field is required',
  },
  registerButton: {
    id: 'interactive-register',
    defaultMessage: 'Register',
  },
  whyChooseUs: {
    id: 'text-why-choose-us',
    defaultMessage: 'Why Choose Us',
  },
  accessTalents: {
    id: 'text-access-million-talents',
    defaultMessage: 'Access 10 Million+ Talents',
  },
  accessTalentsDescription: {
    id: 'text-reach-active-jobseekers',
    defaultMessage:
      'Reach active jobseekers instantly across multiple industries.',
  },
  chatHireTitle: {
    id: 'text-chat-and-hire-talents-directly',
    defaultMessage: 'Chat and Hire Talents Directly',
  },
  chatHireDescription: {
    id: 'text-skip-email-and-slow',
    defaultMessage:
      'Skip emails and slow back-and-forth chat and move candidates forward.',
  },
  automateAITitle: {
    id: 'text-automate-hiring-process-with-ai',
    defaultMessage: 'Automate Hiring Process with AI',
  },
  automateAIDescription: {
    id: 'text-get-matching-candidates',
    defaultMessage:
      'Get matching candidates, so you hire faster with less effort.',
  },
  postFreeJobNow: {
    id: 'interactive-post-free-job',
    defaultMessage: 'Post Free Job',
  },
  recruitAnywhereTitle: {
    id: 'text-recruit-anywhere-chat-instantly',
    defaultMessage: 'Recruit Anywhere, Chat Instantly',
  },
  recruitAnywhereDescription: {
    id: 'text-elevate-your-hiring-experience',
    defaultMessage: 'Elevate your hiring experience with the Glints App today!',
  },
  scanToDownload: {
    id: 'text-scan-to-download',
    defaultMessage: 'SCAN TO DOWNLOAD',
  },
  getItOnGooglePlay: {
    id: 'text-get-it-on-google-play',
    defaultMessage: 'GET IT ON',
  },
  downloadOnAppStore: {
    id: 'text-download-on-app-store',
    defaultMessage: 'Download on the',
  },
  contactUs: {
    id: 'interactive-contact-us',
    defaultMessage: 'Contact Us',
  },
});
